import React, { useEffect } from "react";
import { Toast } from "primereact/toast";

import app from "../../firebase-config";
import MessagesUtil from "../../util/Messages.util";
import EstadoConfig from "../../util/EstadoConfig.util";

function Notification({ toast }) {

  const sounds = {
    5: new Audio("./assets/alarm.mp3"),
    4: new Audio("./assets/aviso.mp3"),
    3: new Audio("./assets/precaucion.mp3"),
    2: new Audio("./assets/nodetectado.mp3"),
    1: new Audio("./assets/falla.mp3"),
  };

  const volume = 0.2;

  function playSound(estado) {
    const sound = sounds[estado];
    if (sound) {
      sound.volume = volume;
      sound.play();
    }
  }

  async function notificationState() {
    await app
      .firestore()
      .collection("notification")
      .doc("sensor")
      .onSnapshot((snap) => {
        const estado = snap.data().estado;
        const message = snap.data().message;

        playSound(estado);

        MessagesUtil.showToast(
          toast,
          EstadoConfig[estado].severity,
          EstadoConfig[estado].label,
          message,
          false,
          6000,
          EstadoConfig[estado].icon,   // 🔥 icono enviado
          { background: EstadoConfig[estado].color, color: "#fff" } // 🔥 color
        );
      });
  }

  useEffect(() => {
    notificationState();
  }, []);

  return <Toast ref={toast} />;
}

export default Notification;
